import React, { FC, useState } from 'react';
import styled from 'styled-components';

import sizes from '../../util/sizes';

import { ProfileTabPanel } from './ProfileTabPanel';
import { Profile } from './Profile';
import { Transactions } from './Transactions';
import { EInvoicingDetails } from './EInvoicingDetails';

interface ProfileContentProps {
  initialTab?: ProfileTabType;
}

export enum ProfileTabNames {
  Transactions = 'Transactions',
  Profile = 'Profile',
  'E-Invoicing details' = 'E-Invoicing details',
}

export type ProfileTabType = keyof typeof ProfileTabNames;

export const ProfileContent: FC<ProfileContentProps> = ({ initialTab }) => {
  const [activeTab, setActiveTab] = useState(initialTab || ProfileTabNames.Transactions);

  const onClick = (tab: ProfileTabNames) => setActiveTab(tab);

  const renderActiveTab = (activeTab: ProfileTabType) => {
    switch (activeTab) {
      case ProfileTabNames.Transactions:
        return <Transactions />;
      case ProfileTabNames.Profile:
        return <Profile />;
      case ProfileTabNames['E-Invoicing details']:
        return <EInvoicingDetails />;
      default:
        return <Transactions />;
    }
  };

  return (
    <ProfileContentContainer>
      <ProfileTabPanel onClick={onClick} activeTab={activeTab} />
      {renderActiveTab(activeTab)}
    </ProfileContentContainer>
  );
};

const ProfileContentContainer = styled.div`
  margin: 0 auto 112px;
  max-width: ${sizes.XL};
`;